import { InputText } from "primereact/inputtext";
import React from "react";
import cx from "classnames";

interface ExtendedInputTextProps {
    value?: string | ReadonlyArray<string> | number | undefined;
    onChange?: (val: string) => void | undefined;
    type?: string | undefined;
    validation?: () => boolean;
    name?: string | null;
    required?: boolean;
    readOnly?: boolean;
    min?: number | string | undefined;
    step?: number | string | undefined;
    onValidStatusChanged?: (status: boolean) => void;
    innerRef?: React.RefObject<HTMLInputElement> | null;
    maxLength?: number | undefined;
}

export default class ExtendedInputText extends React.Component<ExtendedInputTextProps, Record<string, never>> {
    render(): React.ReactNode {
        let error = "";
        if (this.props.required == true && String(this.props.value).length == 0) {
            error = `${this.props.name} is required.`;
        } else if (this.props.validation != null) {
            const isValid = this.props.validation();
            error = isValid == true ? "" : `${this.props.name} is not valid.`;
        }

        const isAnyError = error.length > 0;

        this.props.onValidStatusChanged != null && this.props.onValidStatusChanged(!isAnyError);

        return (
            <>
                <InputText
                    ref={this.props.innerRef}
                    type={this.props.type}
                    min={this.props.min}
                    step={this.props.step}
                    maxLength={this.props.maxLength}
                    value={this.props.value as string}
                    readOnly={this.props.readOnly}
                    className={cx("form-control !h-auto !py-[11px]", isAnyError ? "p-invalid block" : "")}
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => this.props.onChange && this.props.onChange(e.target.value)}
                />
                {isAnyError && <small className="p-error block">{error}</small>}
            </>
        );
    }
}
